<!-- eslint-disable vue/no-deprecated-v-on-native-modifier -->
<template>
    <div class="container">
     <el-header class="content_head">
       <el-row>
           <el-col :span="4">
             <div>
               <el-image style="width:220px; height:40px; margin-top:26px; margin-left: 0px;" :src="require('@/assets/logo@2x.png')"></el-image>
             </div>
           </el-col>
           <el-col :span="16">
             <div class="conent_menu">
               <el-menu :default-active="this.$route.path" router style="border-bottom: none; background-color: transparent;" class="el-menu-demo" mode="horizontal">
                   <el-menu-item index="/">首页</el-menu-item>
                   <el-menu-item @click="scrollToAnchor('idc')">C语言</el-menu-item>
                   <el-menu-item @click="scrollToAnchor('idjava')">Java语言</el-menu-item>
                   <el-menu-item @click="scrollToAnchor('idpython')">Python语言</el-menu-item>
               </el-menu>
             </div>
           </el-col>
           <el-col :span="4">
             <div v-if="userLogin==='0'" class="content_login">
               <el-button-group>
                   <el-button type="primary" icon="el-icon-arrow-left" @click="handleLogin()">登录</el-button>
                   <el-button type="success" @click="handRegister()">注册<i class="el-icon-arrow-right el-icon--right"></i></el-button>
               </el-button-group>
             </div>
             <div v-if="userLogin==='1'" class="content_login">
               <el-dropdown>
                 <span>
                   {{ userName }}
                   <el-icon class="el-icon--right">
                       <arrow-down />
                   </el-icon>
                 </span>
                 <template #dropdown>
                   <el-dropdown-menu>
                     <el-dropdown-item @click.native="handleMyCourse">我的课程</el-dropdown-item>
                     <el-dropdown-item @click.native="handleExit">退出登录</el-dropdown-item>
                   </el-dropdown-menu>
               </template>
               </el-dropdown>
             </div>
           </el-col>
       </el-row>
     </el-header>
   </div>
   <el-dialog v-model="dialogFormVisible"  :width="600" :destroy-on-close="true">
    <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick">
      <el-tab-pane label="登录" name="login_one">
        <el-form  :model="loginForm" class="login_one">
          <el-form-item label="用户" prop="name">
            <el-input clearable v-model="loginForm.name" autocomplete="off" placeholder="请输入用户名" />
          </el-form-item>
          <el-form-item label="密码" prop="psw">
            <el-input v-model="loginForm.psw" type="password" show-password autocomplete="off"
              placeholder="请输入密码" />
          </el-form-item>
          <el-form-item class="login_item">
            <el-button @click="toLogin()">
              <span>登录</span>
            </el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="注册" name="register_two">
        <el-form :model="registerForm" :rules="registerRules" class="register_two">
          <el-form-item label="用户" prop="longinname">
            <el-input clearable v-model="registerForm.longinname" autocomplete="off" placeholder="请输入用户名" />
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input v-model="registerForm.password" type="password" show-password autocomplete="off"
              placeholder="密码由字母、数字或符号组成" />
          </el-form-item>
          <el-form-item label="确认密码" prop="sverifypsw">
            <el-input v-model="registerForm.sverifypsw" type="password" show-password autocomplete="off"
              placeholder="密码由字母、数字或符号组成" />
          </el-form-item>

          <el-form-item class="login_item register_item">
            <el-button @click="registerUser()">注册</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
 </el-tabs>
</el-dialog>
</template>
<script>
import { registerUser, userLogin } from '@/api/userapi'
import { ElMessage } from 'element-plus'
import {mapGetters} from 'vuex'
import { enc, mode, AES, pad } from 'crypto-js';
export default {
name: 'HeadRegion',
computed: {
 ...mapGetters([
   'userId',
   'userName'
 ])
},
props: {
 msg: String
 
},
data() {
 return {
   dialogFormVisible: false,
   loginForm: {
     token: "",
     name: "",
     psw: ""
   },
   registerForm: {
     password: "",
     sverifypsw: "",
     longinname: "",
   },
   activeName: 'login_one',
   userLogin: '0'
 }
},
mounted() {
 console.log("oo")
 console.log(this.userId)
 if( this.userId != null ) {
   this.userLogin = '1'
 }
},
methods:{
 handleLogin() {
   this.$router.push("/ToLogin")
 },
 handRegister() {
   this.$router.push("/ToRegister")
 },
 async toLogin() {
   var encryptpsw = this.jiami(this.loginForm.psw)
   this.loginForm.psw = encryptpsw
   const res = await userLogin(this.loginForm)
   if( res.code != null ) {
     ElMessage.info(res.message)
   } else {
     this.dialogFormVisible = false
     this.$store.commit("setUserId",res.sguid)
     this.$store.commit("setUserName",res.sloginname)
     this.dialogFormVisible = false
     location.reload()
   }
   console.log(res)

 },

 async register(){
   if( this.registerForm.longinname === null || this.registerForm.longinname === '') {
     ElMessage.info("请输入登录账号")
     return
   }

   if( this.registerForm.password != this.registerForm.sverifypsw ) {
     ElMessage.info("密码与确认密码不一致")
     return
   }
   const res = await registerUser(this.registerForm)
   if( res.code === '0' ) {
       this.$store.commit("setUserId",res.id)
       this.$store.commit("setUserName",this.registerForm.longinname)
       this.dialogFormVisible = false
       ElMessage.info(res.message)
       location.reload()

   } else {
     ElMessage.info(res.message)
   }
 },
 registerUser() {
   this.register()
 },
jiami(data){
     var key  = enc.Utf8.parse('o7H8uIM2O5qv65l2');
     var srcs = enc.Utf8.parse(data);
     var encrypted = AES.encrypt(srcs, key, {
       mode:mode.ECB,
       padding: pad.Pkcs7
       });
     return encrypted.toString()
 },
 handleExit() {
   this.$store.commit("RemoveUserId")
   this.$store.commit("RemoveUserName")
   location.reload()
 },
 handleMyCourse() {
   this.$router.push(`/mycourse`)
 },
 scrollToAnchor(item) {
  const element = document.getElementById(item);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
  }

 }
}
}
</script>
<style lang="css" >
.poup_box{
padding: 10px;
line-height: 120px;
}
.el-dialog {
padding: 15px;
line-height: 0px;
}
.el-form{
padding: 15px;
}
.el-form-item{
padding: 10px;
}
.el-dropdown {
 cursor: pointer;
 margin-top: 35px;
}
span:focus {
outline: none;
}
</style>